module.exports = __webpack_public_path__ + "static/media/MagicVision_White2.8bde116c.png";